import { useEffect } from "react";

export default function useClickOutside(refs, callback) {
	useEffect(() => {
		function handleClickOutside(event) {
			for (const ref of refs) {
				if (ref.current && ref.current.contains(event.target)) {
					return;
				}
			}
			callback();
		}
		document.addEventListener("mousedown", handleClickOutside, { capture: true });
		return () => {
			document.removeEventListener("mousedown", handleClickOutside, { capture: true });
		};
	}, [refs, callback]);
}
